module.exports = __webpack_public_path__ + "static/media/lt_call_fake.98c676ce.mp3";